.time {
  background-color: #dfd;
  color: #103810;
  border-radius: 2px;
  white-space: nowrap;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJlY2lwZVRpbWUuc2FzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFO0VBQ0E7RUFDQTtFQUNBIiwic291cmNlc0NvbnRlbnQiOlsiLnRpbWVcbiAgYmFja2dyb3VuZC1jb2xvcjogI2RmZFxuICBjb2xvcjogIzEwMzgxMFxuICBib3JkZXItcmFkaXVzOiAycHhcbiAgd2hpdGUtc3BhY2U6IG5vd3JhcFxuIl19 */